(function () {
    'use strict';

    angular.module("imApp").factory("batchDeliveryListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 744,
                    parameters: parms || {}
                });
            },
            listBatchDeliveries: function (parms) {
                return $ihttp.post({
                    method: 278,
                    parameters: parms || {}
                });
            },
            createBatchDelivery: function (setting) {
                return $ihttp.post({
                    method: 280,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
